import { createTranslationService } from '@services/factories';
import { cacheTranslations } from '@utils/cache-translations';

export enum PinCodeFormTranslation {
    pinCodeFormLabelTemplate = 'pinCodeFormLabelTemplate',
    invalidPinCodeLabel = 'invalidPinCodeLabel',
    submitButton = 'submitButton',
    resendCodeButton = 'resendCodeButton'
}

export const pinCodeFormTranslationContext = 'pinCodeForm';

export const getPinCodeFormTranslations = () => {
    return cacheTranslations(
        createTranslationService(),
        PinCodeFormTranslation,
        pinCodeFormTranslationContext
    );
}



// WEBPACK FOOTER //
// ./src/screens/review-section3/pincode-authorisation/translations.ts